import {
  type FC, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { notNullsy } from '~/_shared/utils/typeGuards';
import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type SidebarAppProps } from '../../sidebar/sidebarAppComponentProps.type';
import { setMapSettingsInitialExpandedIndices } from '../../store/frontendState/leftSidebar/leftSidebar.actionCreators';
import { useFrontendStateLeftSidebarMapSettingsInitialExpandedIndicesSelector } from '../../store/frontendState/leftSidebar/leftSidebar.selectors';
import { useIsMapSettingsSyncInProgressSelector } from '../../store/frontendState/processing/processing.selectors';
import { useBaseMapSettings } from './accordion/baseMap/useBaseMapSettings';
import { useMapMarkersGraphicsSettings } from './accordion/mapMarkersGraphics/useMapMarkersGraphicsSettings';
import { useOtherSettingsSettings } from './accordion/otherSettings/useOtherSettingsSettings';
import { useSharedPresentationalMapsSettings } from './accordion/sharedPresentationalMaps/useSharedPresentationalMapSettings/useSharedPresentationalMapsSettings';
import { MapSettingsComponent } from './mapSettings.component';

const emptyArray: readonly number[] = [];

export const MapSettingsContainer: FC<SidebarAppProps> = props => {
  const dispatch = useDispatch();
  const isMapSettingsLoading = useSelector<boolean>(state => state.map.mapSettings.isLoading);
  const isMapInfoLoading = useSelector<boolean>(state => state.map.mapInfo.isLoading);
  const isMapSettingsSyncInProgress = useIsMapSettingsSyncInProgressSelector();
  const initialExpandedIndices = useFrontendStateLeftSidebarMapSettingsInitialExpandedIndicesSelector();
  const mapStylesProps = useBaseMapSettings();

  useEffect(() => {
    if (notNullsy(initialExpandedIndices)) {
      dispatch(setMapSettingsInitialExpandedIndices(null));
    }
  }, [dispatch, initialExpandedIndices]);

  const mapMarkersGraphicsProps = useMapMarkersGraphicsSettings();
  const sharedPresentationalMapsProps = useSharedPresentationalMapsSettings();
  const otherSettingsProps = useOtherSettingsSettings();

  return (
    <MapSettingsComponent
      {...props}
      baseMapSettingsProps={mapStylesProps}
      initialExpandedIndices={initialExpandedIndices ?? emptyArray}
      isLoading={isMapSettingsLoading || isMapInfoLoading || isMapSettingsSyncInProgress}
      {...mapMarkersGraphicsProps}
      otherSettingsProps={otherSettingsProps}
      sharedPresentationMapProps={sharedPresentationalMapsProps}
    />
  );
};
